import Ajax from '@/lib/ajax'
export default {
    /**
     * 创建积分商品
     * @param data 
     */
    addCarouselPicture(data: any) {
        return Ajax.post(`/api/MarketingManagement/CarouselPicture`, data)
    },
    /**
     * 获取积分商品轮播图
     */
    getCarouselPictureList() {
        return Ajax.get(`/api/MarketingManagement/CarouselPicture/all`);
    }
}